(ns frontend.ui.component.chart.water-fall
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.chart.view :as chart-view]
   [cljs.core :as c]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [frontend.utils :as fu]))

(defn water-fall-config
  [data]
  {:chart       {:type "waterfall"}
   :tooltip     {:useHtml         true
                 :backgroundColor (theme/color [:page-bg :bg])
                 :style           {:opacity         1
                                   :backgroundColor (theme/color [:page-bg :bg])}
                 :enabled         false}
   :plotOptions {:series    {:colorByPoint true
                             :borderWidth  0
                             :dataLabels   {:enabled   true
                                            :inside    false
                                            :formatter (fn [arg]
                                                         (this-as
                                                          js-data-point
                                                          (let [point (js->clj js-data-point
                                                                               :keywordize-keys
                                                                               true)]
                                                            (str (util/->float-1-decimals
                                                                  (fu/absolute-float (:y
                                                                                      point)))))))
                                            :style     {:color       "contrast"
                                                        :textOutline false}}}
                 :waterfall {}}
   :legend      {:enabled false}
   :xAxis       {:type          "category"
                 :categories    (map :name data)
                 :lineColor     (theme/color [:chart :x-axis :line])
                 :gridLineColor (theme/color [:chart :x-axis :grid-line])}
   :yAxis       {:visible       true
                 :title         false
                 :labels        {:format "{text} M€"}
                 :min           (let [min-sum (->> [(first data)
                                                    (last data)]
                                                   (map :y)
                                                   (filter number?)
                                                   (apply min))
                                      max-change (->> data
                                                      (rest)
                                                      (butlast)
                                                      (map :y)
                                                      (filter number?)
                                                      (map (fn [n]
                                                             (if (neg? n)
                                                               (- n)
                                                               n)))
                                                      (apply max))]
                                  (if (and (number? max-change)
                                           (< max-change (* min-sum 0.95)))
                                    (fu/round (* min-sum 0.75) 0)
                                    0))
                 :lineColor     (theme/color [:chart :y-axis :line])
                 :gridLineColor (theme/color [:chart :y-axis :grid-line])}
   :series      [{:data (->>
                         data
                         (map-indexed (fn [idx data-item]
                                        (merge data-item
                                               (cond (= (inc idx) (count data))
                                                     {:isSum true
                                                      :color (color [:chart :waterfall :sum])}
                                                     (zero? idx)
                                                     {:color (color [:chart :waterfall :sum])}
                                                     (neg? (:y data-item))
                                                     {:color (color [:chart :waterfall :down])}
                                                     (pos? (:y data-item))
                                                     {:color (color [:chart :waterfall :up])}))))
                         (doall))}]})

(defn chart
  [data]
  [chart-view/chart (water-fall-config data)])
